import { Linking } from 'react-native';

/**
 * Un `Linking.openURL` sans `.catch` laisse un refus (aucun client mail, magasin injoignable) remonter
 * en rejet de promesse non géré. Adresses fixes de l'application uniquement : pour une adresse venue
 * d'un tiers, c'est `ouvrirAnnonce` qui filtre le schéma.
 */
export function ouvrirLien(url: string): void {
  try {
    void Linking.openURL(url).catch(() => undefined);
  } catch {
    // appel synchrone refusé : rien d'autre à faire qu'ignorer
  }
}
